import apiService from '@common/services/api.service';
import { API } from '@common/services/config';

export default {
    orderBet(token, orderData) {
        const config = {
          params: {
            token
          }
        };
        return apiService.lotte.post(API.ORDER, orderData, config);
    },
}
